import React, { useState, useEffect, useRef } from "react";
import Button from "utils/Button";
import GetAny from "utils/GetAny";
import BlogTwoColumnCardsItems from "./BlogTwoColumnCardsItems";
import Heading from "utils/Heading";

let arrayForHoldingPosts = []

const WorkTwoColumnCards = ({blok}) => {
    const posts = GetAny([], 'thoughts', false, blok.exclude_post)
    const postsPicked = GetAny(blok.items)

    let initialPosts = 7
    const postsPerLoad = 4
    const [postsToShow, setPostsToShow] = useState([])
    const ref = useRef(initialPosts)

    const loopWithSlice = (start, end) => {
        const slicedPosts = posts.slice(start, end)
        arrayForHoldingPosts = arrayForHoldingPosts.concat(slicedPosts)
        arrayForHoldingPosts = [...new Set(arrayForHoldingPosts)];
        setPostsToShow(arrayForHoldingPosts)
    }

    const handleShowMorePosts = () => {
        loopWithSlice(ref.current, ref.current + postsPerLoad)
        ref.current += postsPerLoad
    }

    useEffect(() => {
        loopWithSlice(0, initialPosts)
    }, [])



    return (
        <div className="relative overflow-hidden lg:my-24 my-12">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                {!blok.archive &&
                    <Heading size="h3" className="lg:mb-12 mb-8">{blok.custom_title ? blok.custom_title : 'How about also taking at these.'}</Heading>
                }
                <BlogTwoColumnCardsItems postsToRender={blok.archive ? postsToShow : postsPicked}/>
                <div className="lg:pt-20 md:pt-16 pt-12">
                    {(ref.current < posts.length) && (initialPosts < posts.length) && blok.archive &&
                        <Button onClick={handleShowMorePosts}>Show more</Button>
                    }
                </div>
            </div>
        </div>
    );
};

export default WorkTwoColumnCards;